<template>
  <v-container fluid class="pa-4">
    <!-- Header Card -->
    <v-card class="mb-4 elevation-3">
      <v-card-title class="primary white--text">
        <v-icon left color="white">mdi-calendar-clock</v-icon>
        กำหนดการ รายงานการสำรวจใบอนุญาตประกอบวิชาชีพเฉพาะ ของสถานศึกษา
      </v-card-title>
    </v-card>

    <!-- Main Content Card -->
    <v-card class="elevation-2">
      <v-card-title>
        <v-spacer></v-spacer>
        <v-btn
          color="warning"
          @click="period_collegeEdit()"
          fab
          small
          class="elevation-2"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-simple-table class="modern-table">
          <tbody>
            <tr>
              <td class="font-weight-medium grey--text text--darken-2">ครั้งที่</td>
              <td class="text-center font-weight-bold primary--text">
                {{ period_colleges.period_college_times }}
              </td>
              <td class="font-weight-medium grey--text text--darken-2">ปีการศึกษา</td>
              <td class="text-center font-weight-bold primary--text">
                {{ period_colleges.period_college_year }}
              </td>
            </tr>
            <tr>
              <td class="font-weight-medium grey--text text--darken-2">เริ่มวันที่</td>
              <td class="text-center font-weight-bold">
                {{ formatThaiDate(period_colleges.period_college_start) }}
              </td>
              <td class="font-weight-medium grey--text text--darken-2">สิ้นสุดวันที่</td>
              <td class="text-center font-weight-bold">
                {{ formatThaiDate(period_colleges.period_college_stop) }}
              </td>
            </tr>
     
            <tr>
              <td colspan="2" class="font-weight-medium grey--text text--darken-2">สถานะระบบ</td>
              <td colspan="2" class="text-center">
                <v-chip
                  :color="period_colleges.period_college_enable == 1 ? 'success' : 'error'"
                  text-color="white"
                  small
                >
                  {{ period_colleges.period_college_enable == 1 ? 'เปิดใช้งาน' : 'ปิดใช้งาน' }}
                </v-chip>
              </td>
              
            </tr>
          </tbody>
        </v-simple-table>
      </v-card-text>
    </v-card>

    <!-- Edit Dialog -->
    <v-dialog v-model="editperiod_collegedialog" persistent max-width="800px">
      <v-card>
        <v-card-title class="yellow darken-2 white--text">
          <v-icon left color="white">mdi-clipboard-edit</v-icon>
          แก้ไขกำหนดการสำรวจใบอนุญาตประกอบวิชาชีพเฉพาะ
        </v-card-title>

        <v-card-text class="pt-6">
          <v-form ref="editperiod_collegeform" v-model="valid" lazy-validation>
            <v-row>
              <v-col cols="12" md="6">
                <v-select
                  v-model="editperiod_college.period_college_year"
                  :items="period_collegeselect"
                  item-text="text"
                  item-value="value"
                  label="เลือกปีการศึกษา"
                  outlined
                  dense
                  :rules="[v => !!v || 'กรุณาเลือกปีการศึกษา']"
                  prepend-inner-icon="mdi-calendar"
                ></v-select>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  v-model="editperiod_college.period_college_times"
                  type="number"
                  label="ครั้งที่"
                  outlined
                  dense
                  :rules="[v => !!v || 'กรุณาระบุครั้งที่']"
                  prepend-inner-icon="mdi-numeric"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  v-model="editperiod_college.period_college_start"
                  type="date"
                  label="วันที่เริ่มต้น"
                  outlined
                  dense
                  :rules="[v => !!v || 'กรุณาเลือกวันที่เริ่มต้น']"
                  prepend-inner-icon="mdi-calendar-start"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  v-model="editperiod_college.period_college_stop"
                  type="date"
                  label="วันที่สิ้นสุด"
                  outlined
                  dense
                  :rules="[v => !!v || 'กรุณาเลือกวันที่สิ้นสุด']"
                  prepend-inner-icon="mdi-calendar-end"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <v-card outlined class="pa-3">
                  <div class="d-flex align-center justify-space-between">
                    <div>
                      <div class="font-weight-bold">ระบบสำหรับ สถานศึกษา</div>
                      <div class="text-caption grey--text">เปิด/ปิดการใช้งานระบบ</div>
                    </div>
                    <v-switch
                      v-model="editperiod_college.period_college_enable_sw"
                      color="success"
                      inset
                    ></v-switch>
                  </div>
                </v-card>
              </v-col>            
            </v-row>

            <v-divider class="my-4"></v-divider>
            <div class="text-caption grey--text">
              <v-icon small color="error">mdi-asterisk</v-icon>
              ช่องที่มีเครื่องหมาย * จำเป็นต้องกรอก
            </div>
          </v-form>
        </v-card-text>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn
            large
            outlined
            @click="editperiod_collegedialog = false"
            class="px-6"
          >
            <v-icon left>mdi-close</v-icon>
            ยกเลิก
          </v-btn>
          <v-btn
            large
            color="warning"
            @click="editperiod_collegeSubmit()"
            :loading="loading"
            class="px-6"
          >
            <v-icon left>mdi-content-save</v-icon>
            บันทึกการแก้ไข
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      top
      right
    >
      <div class="d-flex align-center">
        <v-icon left color="white">{{ snackbar.icon }}</v-icon>
        <span>{{ snackbar.text }}</span>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snackbar.show = false"
        >
          ปิด
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import moment from "moment";
import "moment/locale/th";

export default {
  name: "LicenseSurveyPeriod",
  
  data() {
    return {
      loading: false,
      valid: true,
      ApiKey: "HRvec2021",
      editperiod_collegedialog: false,
      
      snackbar: {
        show: false,
        color: "",
        timeout: 5000,
        icon: "",
        text: ""
      },
      
      period_colleges: {},
      editperiod_college: {},
      
      period_collegeselect: [
        { value: "2564", text: "2564" },
        { value: "2565", text: "2565" },
        { value: "2566", text: "2566" },
        { value: "2567", text: "2567" },
        { value: "2568", text: "2568" },
        { value: "2569", text: "2569" },
        { value: "2570", text: "2570" },
        { value: "2571", text: "2571" },
        { value: "2572", text: "2572" }
      ],
      
      data_syslog: {}
    };
  },

  async mounted() {
    moment.locale("th");
    await this.period_collegeQueryAll();
  },

  methods: {
    // Format date to Thai Buddhist calendar
    formatThaiDate(date) {
      if (!date) return "-";
      return moment(date).add(543, "years").format("D MMMM YYYY");
    },

    // Show notification
    showNotification(type, message) {
      const types = {
        success: { color: "success", icon: "mdi-check-circle" },
        error: { color: "error", icon: "mdi-alert-circle" },
        warning: { color: "warning", icon: "mdi-alert" },
        info: { color: "info", icon: "mdi-information" }
      };
      
      this.snackbar = {
        show: true,
        color: types[type].color,
        icon: types[type].icon,
        text: message,
        timeout: 5000
      };
    },

    // Fetch period_college data
    async period_collegeQueryAll() {
      this.loading = true;
      try {
        const result = await this.$http.post("period_college.php", {
          ApiKey: this.ApiKey,
          period_college_id: "601"
        });
        this.period_colleges = result.data;
      } catch (error) {
        this.showNotification("error", "เกิดข้อผิดพลาดในการดึงข้อมูล");
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    // Open edit dialog
    async period_collegeEdit() {
      try {
        const result = await this.$http.post("period_college.php", {
          ApiKey: this.ApiKey,
          period_college_id: "601"
        });
        
        this.editperiod_college = {
          ...result.data,
          period_college_enable_sw: result.data.period_college_enable == 1,
          period_college_enable_sw_process: result.data.period_college_enable_process == 1
        };
        
        this.editperiod_collegedialog = true;
      } catch (error) {
        this.showNotification("error", "เกิดข้อผิดพลาดในการโหลดข้อมูล");
        console.error(error);
      }
    },

    // Submit edit form
    async editperiod_collegeSubmit() {
      if (!this.$refs.editperiod_collegeform.validate()) {
        this.showNotification("warning", "กรุณากรอกข้อมูลให้ครบถ้วน");
        return;
      }

      this.loading = true;
      
      try {
        const submitData = {
          ...this.editperiod_college,
          ApiKey: this.ApiKey,
          period_college_enable: this.editperiod_college.period_college_enable_sw ? "1" : "0",
          period_college_enable_process: this.editperiod_college.period_college_enable_sw_process ? "1" : "0"
        };

        const result = await this.$http.post("period_college.update.php", submitData);
        
        if (result.data.status) {
          this.showNotification("success", "บันทึกข้อมูลเรียบร้อยแล้ว");
          await this.period_collegeQueryAll();
          await this.logSystemEvent("update");
          this.editperiod_collegedialog = false;
        } else {
          this.showNotification("error", "เกิดข้อผิดพลาดในการบันทึกข้อมูล");
        }
      } catch (error) {
        this.showNotification("error", "เกิดข้อผิดพลาดในการเชื่อมต่อ");
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    // Log system event
    async logSystemEvent(eventType) {
      try {
        const userSession = JSON.parse(localStorage.getItem("user")) || {};
        const logData = {
          ApiKey: this.ApiKey,
          user_account: userSession.user_name,
          event_log: eventType,
          page_log: "license_survey_period_college",
          table_log: "period_college",
          date_times: this.getCurrentDateTime()
        };
        
        await this.$http.post("data_syslog.insert.php", logData);
      } catch (error) {
        console.error("Log error:", error);
      }
    },

    // Get current datetime in Thai format
    getCurrentDateTime() {
      const today = new Date();
      const dd = String(today.getDate()).padStart(2, "0");
      const mm = String(today.getMonth() + 1).padStart(2, "0");
      const yyyy = today.getFullYear() + 543;
      const time = `${today.getHours()}:${today.getMinutes()}:${today.getSeconds()}`;
      return `${dd}/${mm}/${yyyy}/${time}`;
    }
  }
};
</script>

<style scoped>
.modern-table tbody tr:hover {
  background-color: #f5f5f5;
  transition: background-color 0.2s;
}

.modern-table td {
  padding: 16px !important;
  border-bottom: 1px solid #e0e0e0;
}

.v-card {
  border-radius: 8px !important;
}

.v-btn {
  text-transform: none;
  font-weight: 500;
}
</style>